import moment from 'moment';

export function checkUnconsecutiveDate(firstDate, secondDate) {
  const diff = moment(firstDate).diff(moment(secondDate), 'days');
  return diff !== 1 && diff !== 0;
}

export function checkUnconsecutiveDateEcheancier(echeanciers, payeurs) {
  let haveUnconsecutiveDate = false;
  echeanciers.forEach((echeancier) => {
    payeurs.forEach((payeur) => {
      const lignes = echeancier.echeancierLignes.filter((echeancierLigne) => {
        return echeancierLigne.tiersId === payeur.tiersId;
      });
      if (lignes.length > 1) {
        for (let index = 1; index < lignes.length; index += 1) {
          if (checkUnconsecutiveDate(lignes[index].dateDebut, lignes[index - 1].dateFin)) {
            haveUnconsecutiveDate = true;
            break;
          }
        }
      }
    });
  });
  return haveUnconsecutiveDate;
}
